import React from 'react';

import { Heading } from '../Heading/Heading';
import NextImage, { ImageLoaderProps } from 'next/image';
import { Text } from '../Text/Text';
import { ContentfulResizeTypes, getContentfulLoader } from '../../helpers/imageLoaders/contentful';

interface IProps {
  imgSrc?: string;
  imgWidth?: number;
  imgHeight?: number;
  title: string;
  body: string;
  className?: string;
}

export const CMSBragCard = ({ imgSrc, imgWidth, imgHeight, title, body, className }: IProps) => {
  const ASPECTWIDTH = 4;
  const ASPECTHEIGTH = 3;

  const contentfulLoader = ({ src, width, quality }: ImageLoaderProps): string =>
    getContentfulLoader(src, width, ASPECTWIDTH, ASPECTHEIGTH, {
      quality,
      resize: ContentfulResizeTypes.FILL,
    });

  return (
    <div className={`flex flex-col items-center gap-4 px-8 sm:px-4 md:px-10 ${className}`}>
      {imgSrc && (
        <NextImage
          alt="Brag bar icon"
          src={imgSrc}
          width={imgWidth}
          height={imgHeight}
          loader={contentfulLoader}
          quality={75}
          className="size-full object-cover"
        />
      )}
      <div className="flex flex-col items-center sm:ml-0">
        <Heading variant="sm" className="mb-2 text-center">
          {title}
        </Heading>
        <Text className="mb-0 text-center">{body}</Text>
      </div>
    </div>
  );
};
